// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"94":"c2b7a729","117":"5839576c","563":"232f5f7c","612":"f101d1e4","774":"90928cd5","787":"58bb828a","994":"b56b68f1"}[chunkId] + ".chunk.js";
};